import { Stack, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { drawMoney, useConfetti } from '../../contexts/ConfettiProvider'

export function Success() {
  const navigate = useNavigate()
  const { showConfetti } = useConfetti()

  useEffect(() => {
    showConfetti({
      numberOfPieces: 200,
      initialVelocityY: -10,
      drawShape: drawMoney,
      recycle: false,
    })
    setTimeout(() => {
      navigate('/')
    }, 2000)
  }, [showConfetti, navigate])
  return (
    <Stack spacing={2} minHeight="300px" justifyContent="center" alignItems="center">
      <Typography variant="h2" color="success" pb={5}>
        Success!
      </Typography>
      <Typography variant="body2">Your payments have been created.</Typography>
    </Stack>
  )
}
